import React from "react";
import { createElementClass } from "../helpers";
export var TableHead = function TableHead(_a) {
  var children = _a.children;
  return React.createElement("thead", {
    className: createElementClass("table-head")
  }, children);
};